import { __assign, __rest } from "tslib";
import React from 'react';
import { cnCalendar } from '../Calendar.const';
import './DateButton.css';
export var DateButton = function (props) {
    var innerRef = props.innerRef, state = props.state, className = props.className, children = props.children, value = props.value, viewDate = props.viewDate, today = props.today, weekend = props.weekend, outside = props.outside, focused = props.focused, disabled = props.disabled, hidden = props.hidden, selected = props.selected, rangeSelected = props.rangeSelected, rangePreview = props.rangePreview, rangePreviewStart = props.rangePreviewStart, rangePreviewEnd = props.rangePreviewEnd, selectionStart = props.selectionStart, selectionEnd = props.selectionEnd, otherProps = __rest(props, ["innerRef", "state", "className", "children", "value", "viewDate", "today", "weekend", "outside", "focused", "disabled", "hidden", "selected", "rangeSelected", "rangePreview", "rangePreviewStart", "rangePreviewEnd", "selectionStart", "selectionEnd"]);
    return (React.createElement("span", __assign({ ref: innerRef, className: cnCalendar('DateButton', {
            today: today,
            weekend: weekend,
            outside: outside,
            focused: focused,
            disabled: disabled,
            hidden: hidden,
            selected: selected,
            rangeSelected: rangeSelected,
            rangePreview: rangePreview,
            rangePreviewStart: rangePreviewStart,
            rangePreviewEnd: rangePreviewEnd,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd,
        }, [className]) }, otherProps), children));
};
